// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"PieChartTable-module--tableContainer--1K_yG","alertContainer":"PieChartTable-module--alertContainer--1Y1Kz"};